// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text_dynamic_table {
  color: #9f9e9e;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  text-transform: capitalize;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  margin: 0;
}

.selectedColumn {
  background-color: #f5bf00;
}

.selectedColumnBlues {
  background-color: #494ef4;
}

.text_dynamic_table1 {
  color: #6b6b6b;
  text-align: center;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.text_dynamic_table_text {
  color: #434343;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 28.8px; /* 205.714% */
  text-align: start;
}

.text_dynamic_table_text1 {
  color: #a4a4a4;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 40px !important;
}

.cursor_point {
  cursor: pointer;
}

.padding_manage {
  padding-top: 8px;
  padding-bottom: 8px;
}

.badge_style_wh {
  color: white !important;
}

.margin_adjust_new {
  margin-top: 3px;
  margin-bottom: -0.2px;
  text-align: start;
}

.margin_top_oftable {
  margin-top: 0.5px;
}

.border_top_orange {
  border-top: 4px solid #F5BF00 !important;
  border-top-left-radius: 5px !important;
}

.dropdown-toggle::after {
  display: none !important;
}

.color_icon_dropdown {
  text-decoration: none;
  color: gray;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Dashboard/MainComponent/new-staff-list/components/Dtable.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,0BAAA;AACF;;AACA;;EAGE,SAAA;AACF;;AACA;EACE,yBAAA;AAEF;;AAAA;EACE,yBAAA;AAGF;;AADA;EACE,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAIF;;AADA;EACE,cAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA,EAAA,aAAA;EACA,iBAAA;AAIF;;AAFA;EACE,cAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,4BAAA;AAKF;;AAHA;EACE,eAAA;AAMF;;AAHA;EACE,gBAAA;EACA,mBAAA;AAMF;;AAHA;EACE,uBAAA;AAMF;;AAHA;EACE,eAAA;EACA,qBAAA;EACA,iBAAA;AAMF;;AAHA;EACE,iBAAA;AAMF;;AAHA;EACE,wCAAA;EACA,sCAAA;AAMF;;AAHA;EACE,wBAAA;AAMF;;AAHA;EACE,qBAAA;EACA,WAAA;AAMF","sourcesContent":[".text_dynamic_table {\n  color: #9f9e9e;\n  font-family: Roboto;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  text-transform: capitalize;\n}\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  // -webkit-appearance: none;\n  margin: 0;\n}\n.selectedColumn {\n  background-color: #f5bf00;\n}\n.selectedColumnBlues {\n  background-color: #494ef4;\n}\n.text_dynamic_table1 {\n  color: #6b6b6b;\n  text-align: center;\n  font-family: Poppins;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n}\n\n.text_dynamic_table_text {\n  color: #434343;\n  font-family: Roboto;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 28.8px; /* 205.714% */\n  text-align: start;\n}\n.text_dynamic_table_text1 {\n  color: #a4a4a4;\n  font-family: Poppins;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 40px !important;\n}\n.cursor_point {\n  cursor: pointer;\n}\n\n.padding_manage {\n  padding-top: 8px;\n  padding-bottom: 8px;\n}\n\n.badge_style_wh {\n  color: white !important;\n}\n\n.margin_adjust_new {\n  margin-top: 3px;\n  margin-bottom: -0.2px;\n  text-align: start;\n}\n\n.margin_top_oftable {\n  margin-top: 0.5px;\n}\n\n.border_top_orange {\n  border-top: 4px solid #F5BF00 !important;\n  border-top-left-radius: 5px !important;\n}\n\n.dropdown-toggle::after {\n  display: none !important;\n}\n\n.color_icon_dropdown {\n  text-decoration: none;\n  color: gray;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
